export const SET_NUMERO_REQUERIMIENTO = (state, value) => {
  state.numeroRequerimiento = value
}

export const SET_RESULT = (state, value) => {
  state.result = value
}

export const SET_ENVIADAS = (state, value) => {
  state.enviadas = value
}

export const SET_REGISTROS = (state, value) => {
  state.registros = value
}

export const SET_COMPROBACION = (state, value) => {
  state.comprobacion = value
}

export const SET_RESULTADO_EXPORTACION = (state, value) => {
  state.resultadoExportacion = value
}

export const SET_PARAMS = (state, value) => {
  state.params = value
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}